import styled from '@emotion/styled';

import colors from 'config/theme/colors';

export const Wrapper = styled.div`
  display: inline-flex;
  flex-direction: column;

  margin-right: 12px;

  border-radius: 4px;
  transition: opacity 0.3s ease-out;
  border: 2px solid ${colors['@body-bg']};

  :hover {
    opacity: 1;
  }
`;

export const Thumbnail = styled.div<{path: string}>`
  height: 88px;
  width: 140px;
  cursor: pointer;
  background-size: cover;
  background-image: url(${({ path }) => path});

  border-radius: 2px 2px 0 0;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  padding: 7px 0;

  > .ant-radio-wrapper {
    margin: 0;
    line-height: 21px;
  }
`;
